import React, { useEffect } from "react";
import {
  createMuiTheme,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Components from "../LandingComponents";
import i18n from "../../../i18n";
import IdiomaContext, { useIdiomaContext } from "./IdiomaContext";
import useIdiomaEvento from "./useIdiomaEvento";
import { resolverTraduccionesSeccion } from "./resolverTraducciones";
import IdiomaSwitcherFlotante from "./IdiomaSwitcherFlotante";

import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export default function LayoutResolver({ page, eventoIndex }) {
  const classes = useStyles();

  console.log(page);
  const defaultWidth = { xs: 12, sm: 6 };
  const widthList = {
    1: { xs: 12, sm: 12 },
    2: { xs: 12, sm: 6 },
    3: { xs: 12, sm: 4 },
    4: { xs: 12, sm: 3 },
    5: { xs: 6, sm: 6 },
    6: { xs: 6, sm: 3 },
  };

  const idiomasSeleccionados =
    (page && page.idiomas && page.idiomas.seleccionados) || [];
  const idiomasDisponiblesPropios = ["es", ...idiomasSeleccionados];
  const traducciones = (page && page.idiomas && page.idiomas.traducciones) || {};
  const traduccionesFijas =
    (page && page.idiomas && page.idiomas.traduccionesFijas) || {};
  const posicionBotonPropio =
    (page && page.idiomas && page.idiomas.posicionBoton) || "top-right";
  const tamanoBotonPropio =
    (page && page.idiomas && page.idiomas.tamanoBoton) || "medium";
  const margenBotonPropio =
    page && page.idiomas && page.idiomas.margenBoton !== undefined
      ? page.idiomas.margenBoton
      : 12;

  const [idiomaPropio, setIdiomaPropio] = useIdiomaEvento(
    eventoIndex,
    idiomasDisponiblesPropios
  );

  // Cuando esta web se renderiza embebida dentro de otra (ej. la web de un
  // evento insertada como sección dentro de la web del organizador, vía
  // EventWeb.jsx), ya existe un IdiomaContext ambiente de la web exterior.
  // Si ese ambiente ya ofrece más de un idioma, se reutiliza su idioma/botón
  // en vez de crear un segundo estado y un segundo botón flotante — así el
  // idioma elegido en cualquiera de las dos aplica a ambas y solo se ve un
  // botón. Si el ambiente no tiene idiomas propios (o no hay ambiente,
  // porque esta es la web más externa), esta instancia actúa como siempre.
  const idiomaAmbiente = useIdiomaContext();
  const anidadoConIdiomaAmbiente =
    idiomaAmbiente.idiomasDisponibles && idiomaAmbiente.idiomasDisponibles.length > 1;

  const idioma = anidadoConIdiomaAmbiente ? idiomaAmbiente.idioma : idiomaPropio;
  const setIdioma = anidadoConIdiomaAmbiente ? idiomaAmbiente.setIdioma : setIdiomaPropio;
  const idiomasDisponibles = anidadoConIdiomaAmbiente
    ? idiomaAmbiente.idiomasDisponibles
    : idiomasDisponiblesPropios;
  const posicionBoton = anidadoConIdiomaAmbiente
    ? idiomaAmbiente.posicionBoton
    : posicionBotonPropio;
  const tamanoBoton = anidadoConIdiomaAmbiente
    ? idiomaAmbiente.tamanoBoton
    : tamanoBotonPropio;
  const margenBoton = anidadoConIdiomaAmbiente
    ? idiomaAmbiente.margenBoton
    : margenBotonPropio;

  useEffect(() => {
    i18n.changeLanguage(idioma);
  }, [idioma]);

  useEffect(() => {
    Object.keys(traduccionesFijas).forEach((lng) => {
      i18n.addResourceBundle(lng, "inscripcion", traduccionesFijas[lng], true, true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(traduccionesFijas)]);

  if (page) {
    const innerComponents = (
      <div className={classes.root}>
        <Grid
          container
          direction="row"
          alignItems="center"
          style={{
            width: "100%",
            textAlign: "center",
            backgroundRepeat: "repeat",
            backgroundPosition: "left top",
            backgroundSize: "100% auto",
            backgroundImage: `url(${
              page.miniTheme ? page.miniTheme.backgroundImage : ""
            })`,
          }}
        >
          {page.views &&
            page.views.map((item, i) => {
              if (Components[item.component] === undefined) {
                return <div></div>;
              }

              const SpecificComponent = Components[item.component].default;

              const width = item.componentConfig.width || 1;

              if (item.componentConfig.hide) {
                return <Grid key={i} item xs={12} sm={12}></Grid>;
              }

              const sectionID = item.componentConfig.sectionID;
              const componentConfigTraducido = resolverTraduccionesSeccion(
                item.componentConfig,
                sectionID ? traducciones[sectionID] : undefined,
                idioma
              );

              return (
                <Grid
                  key={i}
                  id={
                    item.componentConfig.sectionID ||
                    Math.floor(Math.random() * 10000)
                  }
                  item
                  xs={
                    widthList[width] && widthList[width].xs
                      ? widthList[width].xs
                      : defaultWidth.xs
                  }
                  sm={
                    widthList[width] && widthList[width].sm
                      ? widthList[width].sm
                      : defaultWidth.sm
                  }
                  style={{
                    width: "100%",
                    padding: item.componentConfig.padding
                      ? item.componentConfig.padding
                      : 0,
                  }}
                >
                  {SpecificComponent ? (
                    <SpecificComponent componentConfig={componentConfigTraducido} />
                  ) : null}
                </Grid>
              );
            })}
        </Grid>
      </div>
    );

    // Anidado: la web exterior ya provee el contexto e imprime su propio
    // botón flotante — no se crea un segundo provider ni un segundo botón.
    const contenidoConIdioma = anidadoConIdiomaAmbiente ? (
      innerComponents
    ) : (
      <IdiomaContext.Provider
        value={{
          idioma,
          setIdioma,
          idiomasDisponibles,
          posicionBoton,
          tamanoBoton,
          margenBoton,
        }}
      >
        <IdiomaSwitcherFlotante />
        {innerComponents}
      </IdiomaContext.Provider>
    );

    if (page.miniTheme) {
      const { miniTheme } = page;
      return (
        <ThemeProvider
          theme={(theme) => {
            const primaryColor =
              miniTheme.primary || theme.palette.primary.main;
            const secondaryColor =
              miniTheme.secondary || theme.palette.secondary.main;
            const textPrimaryColor =
              miniTheme.text || theme.palette.text.primary || "#000";
            const backgroundColor =
              miniTheme.background ||
              theme.palette.background.default ||
              "#FFFFF";
            const fontFamily =
              miniTheme.fontFamily ||
              theme.typography.fontFamily ||
              "MavenProRegular, MavenProBold,Helvetica, Arial";

            return createMuiTheme({
              ...theme,
              typography: {
                fontFamily: fontFamily,
              },
              palette: {
                background: {
                  default: backgroundColor,
                },
                primary: {
                  main: primaryColor,
                },
                secondary: {
                  main: secondaryColor,
                },
                text: {
                  primary: textPrimaryColor,
                },
              },
            });
          }}
        >
          <Box bgcolor="background.default">{contenidoConIdioma}</Box>
        </ThemeProvider>
      );
    }

    return contenidoConIdioma;
  }

  return null;
}
